import { render, staticRenderFns } from "./main-menu-detail.vue?vue&type=template&id=6b9be5d9"
import script from "./main-menu-detail.vue?vue&type=script&lang=js"
export * from "./main-menu-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports